import Link from "next/link";
import React from "react";

/**
 * Componente que renderiza las secciones del footer.
 *
 * @param {Object} props - Props del componente.
 * @param {Array} props.list - Lista de secciones del footer.
 * Cada sección puede incluir un título y un array de elementos internos.
 * @returns {JSX.Element} - Renderizado de las secciones del footer.
 */
const FooterProps = ({ list }) => {
  return (
    <>
      {list.map((widget, widgetIndex) => {
        // Se desestructura el widget para mayor claridad.
        const { title, innerItem } = widget;
        return (
          <div className="widget-menu-bottom" key={widgetIndex}>
            {title && <h4 className="title">{title}</h4>}
            <div className="inner">
              <ul className="footer-link link-hover">
                {innerItem.map((linkItem, i) => (
                  <li key={i}>
                    {linkItem.icon && (
                      <i
                        className={`contact-icon fa-sharp fa-regular ${linkItem.icon}`}
                        aria-hidden="true"
                      ></i>
                    )}
                    {linkItem.link ? (
                      <Link
                        href={linkItem.link}
                        className="footer-link-text"
                        target={linkItem.target ? linkItem.target : "_self"}
                        rel={
                          linkItem.target === "_blank"
                            ? "noopener noreferrer"
                            : undefined
                        }
                      >
                        {linkItem.text}
                      </Link>
                    ) : (
                      <span className="footer-text">{linkItem.text}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default FooterProps;
